/**
 * @fileoverview Agent definition for world-element-image-creator-fal-v2.
 *
 * This agent generates a world element image from a detailed prompt
 * using the fal.ai provider for high-quality image generation.
 *
 * @category visuals.images.world-building
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'world-element-image-creator-fal-v2',
  kind: 'primitive',
  name: 'World Element Image Creator (FAL)',
  description: 'Generates a world element image from a detailed prompt using the fal.ai provider.',
  category: 'visuals',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-03',
    lastUpdated: '2026-03',
    taxonomyPath: 'visuals.images.world-building',
    usedBy: [
      'generate-world-element-portrait-v2',
    ],
    usedInComposites: [
      'generate-world-element-portrait-v2',
    ],
    relatedAgents: [
      'world-element-image-prompt-creator-v2',
      'portrait-image-creator-fal-v2',
    ],
  },
};
